import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { Lock, Mail, ArrowRight } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { useToast } from '../../hooks/use-toast';
import { LOGO_WHITE } from '../../mock';

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const { toast } = useToast();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      nav('/admin');
    } catch (err) {
      toast({ title: 'Login failed', description: err?.response?.data?.detail || 'Invalid credentials' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0F1C2E] flex items-center justify-center px-6">
      <div className="absolute inset-0 opacity-30" style={{ backgroundImage: 'radial-gradient(circle at 30% 30%, rgba(237,46,46,0.5) 0%, transparent 40%), radial-gradient(circle at 70% 70%, rgba(245,166,35,0.3) 0%, transparent 45%)' }} />
      <div className="relative w-full max-w-md">
        <div className="text-center mb-8">
          <img src={LOGO_WHITE} alt="Wrappus" className="h-24 mx-auto mb-2" />
          <p className="text-white/70 uppercase tracking-widest text-xs">Admin Console</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-3xl p-8 shadow-2xl space-y-5">
          <h1 className="font-heading font-bold text-2xl text-[#0F1C2E]">Welcome back</h1>
          <div>
            <label className="text-sm font-semibold text-[#0F1C2E] block mb-1">Email</label>
            <div className="relative">
              <Mail size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
              <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full pl-11 pr-4 py-3 rounded-xl border border-gray-200 bg-white focus:outline-none focus:border-[#ED2E2E] focus:ring-2 focus:ring-[#ED2E2E]/20" />
            </div>
          </div>
          <div>
            <label className="text-sm font-semibold text-[#0F1C2E] block mb-1">Password</label>
            <div className="relative">
              <Lock size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
              <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full pl-11 pr-4 py-3 rounded-xl border border-gray-200 bg-white focus:outline-none focus:border-[#ED2E2E] focus:ring-2 focus:ring-[#ED2E2E]/20" />
            </div>
          </div>
          <button type="submit" disabled={loading} className="btn-wrappus w-full justify-center disabled:opacity-60">
            {loading ? 'Signing in...' : 'Sign In'} <ArrowRight size={16} />
          </button>
        </form>
      </div>
    </div>
  );
}
